import { render, staticRenderFns } from "./WxBind.vue?vue&type=template&id=d30823b6"
import script from "./WxBind.vue?vue&type=script&lang=js"
export * from "./WxBind.vue?vue&type=script&lang=js"
import style0 from "./WxBind.vue?vue&type=style&index=0&id=d30823b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports